import { createBrowserRouter } from 'react-router';

import AppLayout from './AppLayout';
import { setRouter } from './history';


// A single splat route: public/private route tables are chosen at runtime
// in MainRouter (same as the old <Router><MainRouter/></Router> setup), while
// the data router enables useBlocker for unsaved-form prompts.
export const routes = [
  {
    path: '*',
    element: <AppLayout />,
  },
];

export const createAppRouter = (createRouter = createBrowserRouter, options = undefined) => {
  const router = createRouter(routes, options);
  setRouter(router);
  return router;
};
